class TSProtection extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.handleToggle = this.handleToggle.bind(this);
    this.cartItems = document.querySelector('cart-items') || document.querySelector('cart-drawer-items');
  }

  connectedCallback() {
    this.input.addEventListener('change', this.handleToggle)
  }

  handleToggle(e) {
    const productId = e.target.value;

    this.isProductInCart(productId).then(isInCart => {
      if (isInCart) {
        this.removeFromCart(productId);
      } else {
        this.addToCart(productId, 1);
      }
    });
  }

  addToCart(productId, quantity = 1) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity,
      }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to add product to cart.');
        }
        return response.json();
      })
      .then(() => {
        document.dispatchEvent(new Event('cart:refresh'))
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  removeFromCart(productId) {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        updates: {
          [productId]: 0,
        },
      }),
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to remove product from cart.');
        }
        return response.json();
      })
      .then(() => {
        document.dispatchEvent(new Event('cart:refresh'))
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }

  isProductInCart(variantId) {
    return fetch('/cart.js', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then(response => {
        if (!response.ok) {
          throw new Error('Failed to fetch cart.');
        }
        return response.json();
      })
      .then(cart => {
        const item = cart.items.find(cartItem => cartItem.id == variantId);
        return !!item;
      })
      .catch(error => {
        console.error('Error:', error);
        return false;
      });
  }


}

customElements.define('ts-protection', TSProtection);
